import { render, staticRenderFns } from "./RegisterGroup.vue?vue&type=template&id=ef3b79aa&scoped=true&"
import script from "./RegisterGroup.vue?vue&type=script&lang=js&"
export * from "./RegisterGroup.vue?vue&type=script&lang=js&"
import style0 from "./RegisterGroup.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RegisterGroup.vue?vue&type=style&index=1&id=ef3b79aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef3b79aa",
  null
  
)

export default component.exports